import { render } from "./property-estimatenew.vue?vue&type=template&id=9b8271d6"
import script from "./property-estimatenew.js?vue&type=script&lang=js"
export * from "./property-estimatenew.js?vue&type=script&lang=js"

import "./property-estimatenew.vue?vue&type=style&index=0&id=9b8271d6&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__